// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { NewCostReviewAttributesBase } from '../Classes/NewCostReviewAttributesBase';
import { LaborHoursDistribution } from '../Classes/LaborHoursDistribution';
import { CostByPartNumber } from '../Classes/CostByPartNumber';
import { SubsAndMiscCosts } from '../Classes/SubsAndMiscCosts';
import { LaborByLevel } from '../Classes/LaborByLevel';
import { TaskByLevelWithNotes } from '../Classes/TaskByLevelWithNotes';
import { HoursByLevel } from '../Classes/HoursByLevel';
import { CostReviewPlannedCosts } from '../Classes/CostReviewPlannedCosts';
import { ConditionByLevelWithNotesDetails } from '../Classes/ConditionByLevelWithNotesDetails';
export class NewCostReviewAttributes_SOL extends NewCostReviewAttributesBase {
  override readonly newCostReviewType: string = "NewCostReviewAttributes_SOL";
  laborHoursDistributionDetails: LaborHoursDistribution[];
  costByPartNumberDetails: CostByPartNumber[];
  subsAndMiscCostsDetails: SubsAndMiscCosts[];
  laborByLevelDetails: LaborByLevel[];
  taskByLevelWithNotesDetails: TaskByLevelWithNotes[];
  hoursByLevelDetails: HoursByLevel[];
  costElementsZTC: CostReviewPlannedCosts[];
  autoRiskDollars: number;
  autoRiskPercentageOfTDC: number;
  conditionByLevelWithNotesDetails: ConditionByLevelWithNotesDetails[];
}
